import React from "react"
import { Cell, reduceHooks } from "react-table"

export type CustomStyleColumnAE = {
    HeaderName: string,
    StyleHeader: React.CSSProperties
    condition?: boolean
}

function getGeneralCellAE<T extends Object>(cell: Cell<T>, stylesObjectGeneral: React.CSSProperties, renderObject?: any) {
    return (
        <td
            className={"tableHistorialcolumns"}
            {...cell.getCellProps()}
            style={{ ...stylesObjectGeneral }}
        >
            {
                renderObject !== undefined &&
                renderObject
            }
            {
                renderObject === undefined &&
                (
                    <div>
                        {cell.render('Cell')}
                    </div>
                )
            }

        </td>
    )
}

export function getTdTableStylesAE<T extends Object>(cell: Cell<T>, stylesObjectGeneral: React.CSSProperties, indice?: number, stylesProperties?: Array<CustomStyleColumnAE>, renderObject?: any) {

    if (stylesProperties) {

        var styleforHeader: Array<CustomStyleColumnAE> | undefined = stylesProperties.filter((sp) => sp.HeaderName === cell.column.Header);
        if (styleforHeader.length > 0) {
            var estilosDelRegistro: React.CSSProperties = {}
            styleforHeader.forEach(element => {
                const { StyleHeader, condition } = element;
                if (condition !== undefined && condition) {
                    estilosDelRegistro = { ...estilosDelRegistro, ...StyleHeader };

                }
                else if (condition === undefined) {
                    estilosDelRegistro = { ...estilosDelRegistro, ...StyleHeader };
                }
            });

            const estilosIncorporar: React.CSSProperties = { ...stylesObjectGeneral, ...estilosDelRegistro }

            return getGeneralCellAE(cell, estilosIncorporar, renderObject)
        }
        else {
            return getGeneralCellAE(cell, stylesObjectGeneral, renderObject);
        }
    }
    else {
        return getGeneralCellAE(cell, stylesObjectGeneral, renderObject);
    }
}